/**
 * File Name          : app.routes.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.1.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
 */

import { Routes } from '@angular/router';
import { chromiumBrowserGuard } from './guards/ble-browser.guard';
import { NavbarLayoutComponent } from './layouts/navbar-layout/navbar-layout.component';
import { ChooseUnitComponent } from './views/choose-unit/choose-unit.component';
import { FirmwareupdateComponent } from './views/firmwareupdate/firmwareupdate.component';
import { ChooseLevelComponent } from './views/choose-level/choose-level.component';
import { ChooseLessonComponent } from './views/choose-lesson/choose-lesson.component';
import { LearningLayoutComponent } from './layouts/learning-layout/learning-layout.component';
import { UnsupportedBrowserComponent } from './views/unsupported-browser/unsupported-browser.component';

export const routes: Routes = [
    {
        path: 'home',
        component: NavbarLayoutComponent,
        canActivate: [chromiumBrowserGuard],
        children: [
            {
                path: '',
                component: ChooseUnitComponent,
            },
            {
                path: 'firmware-update/:deviceId',
                component: FirmwareupdateComponent
            },
            {
                path: ':unitId',
                component: ChooseLevelComponent
            },
            {
                path: ':unitId/:levelId',
                component: ChooseLessonComponent
            },
            {
                path: ':unitId/:levelId/:lessonId',
                component: LearningLayoutComponent
            },

        ]
    },
    
    {
        path: 'unsupported-browser',
        component: UnsupportedBrowserComponent
    },
    
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: '**', redirectTo: 'home' }
];

